import { Spinner } from '@consigli/facade';
import { FC } from 'react';

interface DocumentLoadingPaneProps {
  caption?: string;
}

// Loading placeholder rendered *inside* the AECOM DocumentViewer, standing in
// for a pane whose signed URL has not resolved yet. This lets the drawer open
// immediately with a spinner where the document will appear, instead of the
// viewer briefly returning a bare loader that lands at the bottom of the page.
//
// The data-attributes are the library's own pane layout contract:
// `-main` is the pane wrapper (fills its grid cell in single view and takes
// `flex: 1` inside a comparison layout), and `-pane-caption` pins the title bar
// the built-in panes render — so a comparison pane keeps its heading while its
// neighbour is still loading.
export const DocumentLoadingPane: FC<DocumentLoadingPaneProps> = ({ caption }) => (
  <div data-ds-document-viewer-main="" className="flex flex-col">
    {caption && <div data-ds-document-viewer-pane-caption="">{caption}</div>}
    <div className="flex flex-1 items-center justify-center p-6">
      <Spinner size="large" />
    </div>
  </div>
);
